<template>
  <div class="imgUploader">
    <div class="file-list">
      <section v-for="file in imgStore" :key="file.key" class="file-item draggable-item">
        <img :src="file.src" alt="" ondragstart="return false;" />
        <span class="file-remove" @click="remove(file.key)">+</span>
        <span class="flie-loading" v-if="imgStatus === 'uploading'">上传中...</span>
        <span class="flie-finished" v-if="imgStatus === 'finished'">已上传</span>
      </section>
      <section class="file-item" v-if="imgStatus !== 'finished' && imgStore.length < 5">
        <div class="add">
          <span><i class="fa fa-camera"></i></span>
          <!-- accept="image/jpeg,image/png" capture="camera" -->
          <input type="file" multiple accept="image/*" @change="selectImgs" ref="file" />
        </div>
      </section>
    </div>
    <div class="uploadBtn">
      <section class="originCheckbox">
        <input type="checkbox" name="" id="originImg" v-model="originImg" />
        <label for="originImg">原图上传</label>
      </section>
      <section>
        <span v-if="imgStore.length > 0" class="empty" @click="empty">
          {{ imgStatus === 'finished' ? '重新上传' : '清空' }}
        </span>
      </section>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// 图片压缩上传参考： https://www.cnblogs.com/007sx/p/7583202.html
/**
  file：一个是文件(类型是图片格式)，
  w：一个是文件压缩的后宽度，宽度越小，字节越小
  objDiv：一个是容器或者回调函数
  photoCompress()
*/
function photoCompress(file, w, objDiv) {
  var ready = new FileReader()
  /*开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
  ready.readAsDataURL(file)
  ready.onload = function () {
    var re = this.result
    canvasDataURL(re, w, objDiv)
  }
}
function canvasDataURL(path, obj, callback, quality = 0.7) {
  var img = new Image()
  img.src = path
  img.onload = function () {
    var that = this
    // 默认按比例压缩
    var w = that.width,
      h = that.height,
      scale = w / h
    w = obj.width || w
    h = obj.height || w / scale
    //生成canvas
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    // 创建属性节点
    var anw = document.createAttribute('width')
    anw.nodeValue = w
    var anh = document.createAttribute('height')
    anh.nodeValue = h
    canvas.setAttributeNode(anw)
    canvas.setAttributeNode(anh)
    ctx.drawImage(that, 0, 0, w, h)
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality
    }
    // quality值越小，所绘制出的图像越模糊
    var base64 = canvas.toDataURL('image/jpeg', quality)
    // 回调函数返回base64的值
    callback(base64)
  }
}

/**
 * 将以base64的图片url数据转换为Blob
 * @param urlData
 * 用url方式表示的base64图片数据
 */
function convertBase64UrlToBlob(urlData) {
  var arr = urlData.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  let parts = filename.split('.')
  parts[parts.length - 1] = mime.split('/')[1]
  filename = parts.join('.')
  return new Blob([u8arr], { type: mime })
}

// 将base64转换为文件: https://www.cnblogs.com/wangzhaobo/p/9185522.html
function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  let parts = filename.split('.')
  parts[parts.length - 1] = mime.split('/')[1]
  filename = parts.join('.')
  return new File([u8arr], filename, { type: mime })
}

import { mapState } from 'vuex'
export default {
  props: ['url'],
  data() {
    return {
      originImg: false,
      files: [], // 压缩后的文件
      filesOrigin: [], // 原始文件
      index: 0, // 压缩后的图片序列号
      indexOrigin: 0, // 原始图片序列号
      maxLength: 5 // 图片最大数量
    }
  },
  computed: {
    ...mapState({
      imgStoreOrigin: (state) => state.imgstore.img_upload_cache_origin.slice(0, 5),
      imgStore: (state) => state.imgstore.img_upload_cache.slice(0, 5),
      imgPaths: (state) => state.imgstore.img_paths,
      imgStatus: (state) => state.imgstore.img_status
    })
  },
  methods: {
    // 选择图片
    selectImgs() {
      let fileList = this.$refs.file.files
      // 为什么要写两次for循环？这里遇到一个很奇怪的问题，如果将这些逻辑写在同一个for循环中，存储的图片始终是压缩之后的图片
      // 存储原始图片
      for (let i = 0, len = fileList.length; i < len; i++) {
        let item = {
          key: this.indexOrigin++,
          name: fileList[i].name,
          size: fileList[i].size,
          file: fileList[i]
        }
        console.log(item.file)

        // 存储原始图片
        this.filesOrigin.push(item)
      }
      this.filesOrigin.splice(5)
      this.$store.commit('set_img_upload_cache_origin', this.filesOrigin.slice(0, 5)) // 存储文件缓存
      // 存储压缩后的图片
      for (let i = 0, len = fileList.length; i < len; i++) {
        let item = {
          key: this.index++,
          name: fileList[i].name,
          size: fileList[i].size,
          file: fileList[i]
        }
        // 将图片文件转成BASE64格式
        let reader = new FileReader()
        reader.onload = (e) => {
          this.$set(item, 'src', e.target.result)
        }
        reader.readAsDataURL(fileList[i])
        // console.log(`图片[${i}]，原图：${fileList[i].size / 1024}KB`);
        if (fileList[i].size / 1024 / 500 < 1) {
          // 图片小于500KB不进行压缩，如进行压缩图片大小可能会增大
          this.files.push(item)
          this.files.splice(5)
          this.$store.commit('set_img_upload_cache', this.files.slice(0, 5)) // 存储文件缓存
        } else {
          // 对图片尺寸大于1MB的图片进行压缩
          photoCompress(
            fileList[i],
            {
              quality: 0.8
            },
            (base64Codes) => {
              // console.log(`图片[${i}]，压缩后：${base64Codes.length / 1024}KB`);
              let file = dataURLtoFile(base64Codes, item.name)
              item.file = file
              item.name = file.name
              item.size = file.size
              this.files.push(item)
              this.files.splice(5)
              this.$store.commit('set_img_upload_cache', this.files.slice(0, 5)) // 存储文件缓存
            }
          )
        }
      }
      this.$store.commit('set_img_status', 'selected') // 更新文件上传状态
    },
    // 上传图片
    submit() {
      let formData = new FormData()
      if (this.originImg) {
        // 原图上传
        this.imgStoreOrigin.forEach((item, index) => {
          item.name = 'imgFiles[' + index + ']'
          //formData.append(item.name, item.file)
          formData.append('imgFiles[]', item.file, item.file.name)
          formData.append('key[]', item.file.name)
        })
      } else {
        // 压缩上传
        if (this.imgStoreOrigin.length !== this.imgStore.length) {
          this.$toast('图片压缩处理中，请稍后...')
          return
        }
        this.imgStore.forEach((item, index) => {
          item.name = 'imgFiles[' + index + ']'
          //formData.append(item.name, item.file)
          formData.append('imgFiles[]', item.file, item.file.name)
          formData.append('key[]', item.file.name)
          alert(item.file.name)
          alert(item.file.size)
        })
      }

      // 新建请求
      const xhr = new XMLHttpRequest()
      xhr.open('POST', this.url, true)
      xhr.send(formData)
      xhr.onreadystatechange = function () {}
      xhr.onload = () => {
        // alert('load')
        if (xhr.status === 200 || xhr.status === 304) {
          console.log(xhr)
          console.log(xhr.responseText)
          let datas = JSON.parse(xhr.responseText)
          let flag = true
          datas.forEach((data) => {
            if (data.error === -1) {
              flag = false
            }
          })
          // 存储返回的地址
          if (flag) {
            let imgUrlPaths = []
            datas.forEach((e) => {
              // error === 0为成功状态
              e.error === 0 && imgUrlPaths.push(e.url)
            })
            this.$store.commit('set_img_paths', imgUrlPaths) // 存储返回的地址
            this.files = [] // 清空文件缓存
            this.filesOrigin = [] // 清空文件缓存
            this.index = 0 // 初始化序列号
            this.$store.commit('set_img_status', 'finished') // 更新文件上传状态
          } else {
            alert('图片上传失败，请重新上传!')
            this.$store.commit('set_img_status', 'ready') // 更新文件上传状态
            this.empty()
            flag = true
          }
        } else {
          this.$toast(`${xhr.status} 请求错误!`)
        }
      }
    },
    // 移除图片
    remove(index) {
      this.files = this.files.filter((file) => {
        return file.key !== index
      })
      this.filesOrigin = this.files.filter((file) => {
        return file.key !== index
      })
      this.$store.commit('set_img_upload_cache', this.files) // 更新存储文件缓存
      this.$store.commit('set_img_upload_cache_origin', this.filesOrigin) // 更新存储文件缓存
    },
    // 清空图片
    empty() {
      this.files.splice(0, this.files.length)
      this.filesOrigin.splice(0, this.filesOrigin.length)
      this.$store.commit('set_img_upload_cache', this.files) // 更新存储文件缓存
      this.$store.commit('set_img_upload_cache_origin', this.filesOrigin) // 更新存储文件缓存
      this.$store.commit('set_img_paths', [])
    }
  },
  beforeCreate() {
    this.$store.commit('set_img_status', 'ready') // 更新文件上传状态
  },
  destroyed() {
    this.$store.commit('set_img_upload_cache', [])
    this.$store.commit('set_img_upload_cache_origin', [])
    this.$store.commit('set_img_paths', [])
  },
  watch: {
    imgStatus() {
      if (this.imgStatus === 'uploading') {
        this.submit()
      }
    },
    imgStore() {
      if (this.imgStore.length <= 0) {
        this.$store.commit('set_img_status', 'ready') // 更新文件上传状态
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
.imgUploader {
  margin: 1em 0 2em;
  border: 1px solid #e5e5e5;
  .file-list {
    padding: 10px 0px;
    &::after {
      content: '';
      display: block;
      clear: both;
      visibility: hidden;
      line-height: 0;
      height: 0;
      font-size: 0;
    }
    .file-item {
      float: left;
      position: relative;
      width: 100px;
      text-align: center;
      img {
        width: 80px;
        height: 80px;
        border: 1px solid #ececec;
      }
      .file-remove {
        position: absolute;
        right: 12px;
        top: 4px;
        width: 14px;
        height: 14px;
        color: white;
        cursor: pointer;
        line-height: 12px;
        border-radius: 100%;
        transform: rotate(45deg);
        background: rgba(0, 0, 0, 0.5);
      }
      .flie-loading {
        position: absolute;
        left: 0;
        right: 0;
        top: 1em;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
      }
      .flie-finished {
        position: absolute;
        left: 0;
        right: 0;
        top: 1em;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
      }
      &:hover .file-remove {
        display: inline;
      }
      .file-name {
        margin: 0;
        height: 40px;
        word-break: break-all;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
  .add {
    width: 80px;
    height: 80px;
    margin-left: 10px;
    float: left;
    text-align: center;
    line-height: 80px;
    font-size: 30px;
    cursor: pointer;
    border: 1px dashed @bd_color;
    color: @sub_color;
    position: relative;
    background: @bd_color;
    .fa {
      font-size: 1.4em;
      color: #7dd2d9;
    }
  }
  .uploadBtn {
    position: relative;
    .originCheckbox {
      display: flex;
      align-items: center;
      margin: 1em;
    }
    .empty {
      position: absolute;
      right: 0;
      bottom: 0;
      background-color: @main_color;
      color: #fff;
      padding: 0.2em 1em;
    }
  }
}
input[type='file'] {
  position: absolute;
  left: 0;
  top: 0;
  width: 80px;
  height: 80px;
  border: 1px solid #000;
  opacity: 0;
}
</style>
